import React, { useState, useRef, useEffect } from "react";
import backArrowIcon from "../../assets/images/top-back-arrow.svg";
import { Link, useNavigate } from "react-router-dom";
import cancelIcon from '../../assets/images/cancel-icon.svg'
import SignaturePad from "react-signature-canvas";
import { InnLoader } from "../innLoader";
import { useDispatch, useSelector } from "react-redux";
import { propertyDetails, setSignatureImagePath } from "../../reducer/selfCheckinSlice";


function Signature() {
    const sigCanvas = useRef({});
    const clear = () => sigCanvas.current.clear();
    const propertyDetailObj = useSelector(propertyDetails);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isActive, setIsActive] = useState(false);
    const wait = timeOut => {
        return new Promise(resolve => setTimeout(resolve, timeOut));
    }

    const onSaveSign = () => {
        const ImageUrl = sigCanvas.current.toDataURL();
        dispatch(setSignatureImagePath(ImageUrl))
        navigate("/Registration1")
    }
    const onCancelClick = () => {
        dispatch(setSignatureImagePath(''));
        navigate("/Registration1")
    }
    useEffect(() => {
        setIsActive(true);
        if (propertyDetailObj === undefined) {
            navigate("/Unauthorised")
        }
        wait(1000).then(() => setIsActive(false))
    }, [])

    return (
        <div>
            <InnLoader className={isActive ? "active" : null}></InnLoader>
            <div className="top-blue-bg">
                <Link to="/Registration1">
                    <div className="top-back-arrow">
                        <img src={backArrowIcon} />
                    </div>
                </Link>
                <div className="top-blue-hdng">
                    <h2 className="text-left">Signature</h2>
                </div>
                <div className="top-blue-bg-icon">
                    {/* <Link to="/Registration1"> */}
                        <button className="grey-btn" onClick={onCancelClick}>Cancel</button>
                    {/* </Link> */}
                    <button className="light-blue-btn" onClick={onSaveSign}>Save</button>
                </div>
            </div>
            <div className="parant-dt-div">
                <div className="reg-sign-label">Please sign digitally below</div>
                {/*  <div id="signbox" className="sign-box" style={{ width: 'auto', height: 500 }}>
                    <div id="canceldiv" className="sign-csl">
                        <img src={cancelIcon} /></div>
                </div> */}
                <div id="signbox" className="sign-box" style={{ width: 'auto', height: 500 }}>
                    <div id="canceldiv" className="sign-csl">
                        <img src={cancelIcon} onClick={clear} /></div>

                    <SignaturePad
                        ref={sigCanvas}
                        canvasProps={{
                            className: "signatureCanvas",
                        }}
                        backgroundColor="rgb(255,255,255)"
                    />

                </div>
            </div>
            <div className="overlay">
                <div className="overlay-background"></div>
                {/* <div  className="overlay-content"><span
                    className="spinner"></span>&nbsp;&nbsp;&nbsp;Loading
                </div> */}
            </div>
            <div className="hidden">
                <div className="loader-overlay"></div>
            </div>
        </div>
    )
}

export default Signature


